<script lang="ts" setup>
import { computed } from 'vue'

import { usePageStore } from '@toni/rendering/src/stores/page'
import { Quote, QuoteText, QuoteAuthor, LineIcon, QuoteIcon, BlockContainer } from '@toni/brand-ui'

import { usePageBlockWidth } from '../../composables/use-page-block-width.ts'
import { useContentBlock } from '../../content-blocks/composables/use-content-block'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'quote')

const pageStore = usePageStore()
const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)
const hasAuthor = computed(() => contentBlock.value.data.quote.author && contentBlock.value.data.quote.author.trim() !== '')

const quoteStyleClasses = computed(() => {
  return {
    'flex flex-col gap-3 mt-6': true,
    'mb-4 sm:float-left sm:w-[300px] sm:mr-6 sm:ml-0 md:ml-[100px] lg:mr-10 xl:ml-[100px]': pageStore.pageData?.pageMeta?.pageType === 'article'
  }
})
</script>

<template>
  <BlockContainer v-if="!contentBlock.shouldFloat"
                  :size="size">
    <Quote class="flex flex-col gap-3 mt-6">
      <QuoteIcon v-if="hasAuthor"
                 class="mb-1" />
      <LineIcon v-else
                class="mb-1" />
      <QuoteText>{{ contentBlock.data.quote.text }}</QuoteText>
      <QuoteAuthor v-if="hasAuthor"
                   class="text-secondary-foreground">
        {{ contentBlock.data.quote.author }}
      </QuoteAuthor>
    </Quote>
  </BlockContainer>
  <Quote v-else
         :class="quoteStyleClasses">
    <QuoteIcon v-if="hasAuthor"
               class="mb-1" />
    <LineIcon v-else
              class="mb-1" />
    <QuoteText>{{ contentBlock.data.quote.text }}</QuoteText>
    <QuoteAuthor v-if="hasAuthor"
                 class="text-secondary-foreground">
      {{ contentBlock.data.quote.author }}
    </QuoteAuthor>
  </Quote>
</template>
